module.exports = __webpack_public_path__ + "media/images/lb/018-9dfba217db2c1e92e733ca1b2cac1d15.svg";